$(() => {
    $(window).scroll(function() {
        if ($(this).scrollTop() > 80) {
            $('body').addClass('header-fixed-top');
        } else if ($(this).scrollTop() < 25) {
            $('body').removeClass('header-fixed-top');
        }
    });
});